const categoryOrder = { asset: 0, liability: 1, equity: 2, income: 3, revenue: 3, expense: 4 }
const categoryRank = category => {
  return Object.prototype.hasOwnProperty.call(categoryOrder, category) ? categoryOrder[category] : 5
}

function uniqueDescriptions (items) {
  const descriptions = new Map()
  items.forEach(item => {
    const title = String(item.title || '').trim().replace(/\s+/g, ' ')
    const amount = Number(item.amount) || 0
    if (descriptions.has(title)) {
      descriptions.get(title).amount += amount
    } else {
      descriptions.set(title, { ...item, title, amount })
    }
  })
  return Array.from(descriptions.values())
}

export default function voucherPrintDescriptions (data) {
  const lines = data.journal && data.journal.lines
  if (Array.isArray(lines) && lines.length) {
    const descriptions = lines.map((line, index) => ({ line, index }))
      .sort((a, b) => categoryRank(a.line.account_category) - categoryRank(b.line.account_category) || a.index - b.index)
      .map(entry => ({ id: `journal-${entry.index}`, title: entry.line.description || '', amount: Number(entry.line.debit || entry.line.credit) || 0 }))
    const extras = (data.journal.extra_items || []).map((item, index) => ({
      id: `extra-${index}`, title: item.title, amount: Number(item.amount) || 0
    }))
    return uniqueDescriptions(descriptions.concat(extras))
  }

  return uniqueDescriptions([...(data.description || [])].sort((a, b) => b.amount - a.amount))
}
